import { Components, Theme, Fade, PaletteMode } from '@mui/material';
import { themePalette } from '../theme.palette';

export const MuiDialogTheme = (mode: PaletteMode): Components<Theme>['MuiDialog'] => {
  const { tokens } = themePalette(mode);
  return {
    defaultProps: {
      // Configure fade transition with 300ms duration
      slots: {
        transition: Fade,
      },
      slotProps: {
        transition: {
          timeout: 300,
        },
      },
    },
    styleOverrides: {
      paper: {
        // Override MUI default paper styles to match Modal component
        background: tokens.background.brand.dark.base,
        boxShadow: 'none',
        overflow: 'visible',
        position: 'relative',
        zIndex: 1,
      },
    },
  };
};
